import { Modal } from 'antd';

/**
 * 确认对话框
 * @params 
 */
export default ({type, title, content, okText, onOk}) => {
  Modal[type]({
    title,
    content,
    okText: okText || '确定',
    onOk,
  })
}


// WEBPACK FOOTER //
// ./src/util/confirm.js